import React from 'react';
import Row from 'react-bootstrap/Row';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import {
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag,
  getLuxeFlags
} from '../../../Flags/selectors';
import { getIsPriceRevealPDP, getShowPriceRevealOnSimilar } from '../../../utils/pdp';
import { addCustomerType } from '../../../utils/products';
import { redirect } from '../../../refresh/utils/cartUtils';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import luxeList from '../../../refresh/constants/luxeScreenType';
import {
  luxeGtmProductClick,
  gtmListingProductImpressions,
  getStoreName,
  gtmProductClick,
  segmentEventPush
} from '../../../modules/ga/GTMdatalayer';
import { getPriceRevealSaleDuration } from '../../common/PriceRevealPLPBanner/priceRevealUtil';
import PriceRevealPLP from '../../common/ListingPage/priceRevealPLP/PriceRevealPLP';
import { getDiscountValue } from '../../../utils/price';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import { getStoresForHidingMRP, getGiftWithProductEnable, getGiftWithProductConfig } from '../../../refresh/selectors/featureFlagsSelector';
import { catalogIdToStoreName } from '../../../utils';
import { checkProductId, setProductId } from '../../../utils/productWidget';

import { readCookie } from '../../common/Cookie';
import properties from '../../../modules/ajio-util/properties';
import { setLandingPageScrollCookies } from '../../../utils/banner';
import {
  handleProductImpressionsForDynamicWidget,
  handleWindowUnloadForDynamicWidgetProductImpressions
} from '../../../fleek/utils/feedGaUtils';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const imageBaseUrl = properties.getProperty('imageBaseUrl');
const productWidgetDataListLocalVariable = 'productWidgetDataListWeb';
const dynamicWidgetProductImpressionsIdWeb = 'dynamicWidgetProductImpressionsIdWeb';
const dynamicWidgetProductImpressionsDataWeb = 'dynamicWidgetProductImpressionsDataWeb'; 


class ProductWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialIndex: 4,
      previousIndex: 0,
      hasObserverBlockCall: false
    };
    this.productWidgetBlockRef = React.createRef();
  }

  componentDidMount() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.state.hasObserverBlockCall) {
          this.setState({ hasObserverBlockCall: !this.state.hasObserverBlockCall });
          this.handleObserver();
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    if (this.productWidgetBlockRef.current) observer.observe(this.productWidgetBlockRef.current);
    window.addEventListener('beforeunload', this.handleUnloadEvent);
  }

  componentWillUnmount() {
    // Clean up the observer when the component unmounts
    window.removeEventListener('beforeunload', this.handleUnloadEvent);
  }

  handleUnloadEvent = () => {
    const { newDesignLuxe } = this.props;

    handleWindowUnloadForDynamicWidgetProductImpressions(
      dynamicWidgetProductImpressionsDataWeb,
      !!newDesignLuxe
    );
  };

  handleObserver = () => {
    const { productWidgetData = [] } = this.props;
    if (productWidgetData && productWidgetData.length)
      this.productImpressionsEventPush(productWidgetData.slice(0, 4));
  };

  productImpressionsEventPush = product => {
    const { newDesignLuxe, heading, rowNumber, componentName, bannerType, banners, enableGiftWithProduct, giftWithProductConfig } = this.props;
    const isDynamicProductWidget = bannerType === 'DYNAMIC_WIDGET' || false;
    let { landing: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const storeType = getStoreName();
    let impressions = [];
    product?.map((data, index) => {
      const {
        name: description,
        brand,
        code = '',
        price: { value: priceValue = '' },
        fnlColorVariantData: {
          colorGroup: productColor = '',
          exclusiveTill: isExclusive = '',
          productTag = ''
        } = {},
        brickCategory: productCategory = '',
        brickName,
        discount = '',
        catalogName = '',
        segmentId = '',
        experimentId = '',
        offerPrice = {}
      } = data;

      const { giftAvailable = false } = offerPrice;
      const productId = code && code.length > 9 ? code.substring(0, 9) : code;
      const tag = isExclusive ? 'Exclusive' : productTag;
      let listValue = `${screenName} - ${heading}`;
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
      if (isDynamicProductWidget) {
        listValue =
          banners.widgetLevel.toLowerCase() === 'user'
            ? `user_level_${banners?.feedLogic}_${heading}_${rowNumber}`
            : `dynamic_${banners?.feedLogic}_${heading}_${rowNumber}`;
      }

      let impressionData = {
        name: description,
        id: productId,
        price: priceValue,
        brand,
        category: productCategory,
        list: listValue,
        position: index,
        dimension6: description,
        dimension7: productId, // pass value for product_id
        dimension8: brand, // pass value for product_brand
        dimension9: priceValue, // pass value for product_price
        dimension10: productColor, // pass value for product_color
        dimension11: productCategory, // pass value for product_category
        dimension12: brickName, // pass value for product_brick
        dimension13: tag, // pass value for product_tag
        dimension14: '', // pass value for product_size
        dimension15: discount, // pass value for product_trade_discount
        dimension16: storeType, // pass value for Store_type,
        dimension23: catalogIdToStoreName(catalogName),
        dimension60: dimension60Data,
        dimension166: (enableGiftWithProduct && giftAvailable) ? 'GetFreebies' : '',
        dimension170: getDiscountValue(discount),
        catalogName: catalogName ?? "",
      };
      const isProductIdExists = checkProductId(productId, productWidgetDataListLocalVariable);
      if (!isProductIdExists) {
        impressions.push(impressionData);
        setProductId(productId, productWidgetDataListLocalVariable);
      }
    });
    if (impressions.length > 0) {
      if (isDynamicProductWidget) {
        impressions.forEach(imprsn => {
          handleProductImpressionsForDynamicWidget(
            dynamicWidgetProductImpressionsDataWeb,
            dynamicWidgetProductImpressionsIdWeb,
            imprsn,
            storeType,
            '',
            screenType,
            '',
            !!newDesignLuxe
          );
        });
      } else {
        gtmListingProductImpressions({
          impressions,
          list: 'landing screen',
          store_type: storeType,
          page_name: '',
          page_type: screenType,
          contains_luxe: !!newDesignLuxe
        },'','','','','','',null,'ProductWidget','Horizontal', '');
      }
    }
  };


  onNextClick = index => {
    const { productWidgetData } = this.props;
    const { initialIndex, previousIndex } = this.state;
    const { bannerType } = this.props;
    const isDynamicProductWidget = bannerType === 'DYNAMIC_WIDGET' || false;
    const isForward = index > previousIndex;
    if (!isDynamicProductWidget && index + 1 > initialIndex) {
      this.setState({ initialIndex: initialIndex + 4, previousIndex: previousIndex + 4 });
    } else if (isDynamicProductWidget) {
      this.setState({ initialIndex: initialIndex + 1, previousIndex: previousIndex + 1 });
    }
    this.productImpressionsEventPush(productWidgetData.slice(previousIndex + 1, initialIndex + 1));
    announceCarouselChange(isForward ? 'next' : 'previous');
  };

  render() {
    const {
      metaData = {},
      priceRevealMetaInfoProductWidget,
      productWidgetData,
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData = {},
      store,
      priceRevealLUXEFlag,
      newDesignLuxe,
      eventPush,
      currentStore,
      flags,
      storesForHidingMRP,
      bannerType,
      ctaSettings,
      viewShowMoreProducts,
      dynamicProductWidgetRedirection,
      heading,
      rowNumber,
      banners,
      enableGiftWithProduct,
      giftWithProductConfig,
      isPriceReveal = false
    } = this.props;
    const priceRevealMetaInfo = priceRevealMetaInfoProductWidget;
    // const isPriceReveal = getPriceRevealSaleDuration(
    //   flags,
    //   'desktop',
    //   priceRevealMetaInfo,
    //   newDesignLuxe ? 'luxe' : 'ajio'
    // );
    return (
      <div className="comp-section product-widget" ref={this.productWidgetBlockRef}>
        <DataList
          storesForHidingMRP={storesForHidingMRP}
          data={productWidgetData}
          metaData={metaData}
          isPriceReveal={isPriceReveal}
          eventPush={eventPush}
          newDesignLuxe={newDesignLuxe}
          currentStore={currentStore}
          onNextClick={this.onNextClick}
          priceRevealMetaInfo={priceRevealMetaInfo}
          bannerType={bannerType}
          ctaSettings={ctaSettings}
          viewShowMoreProducts={viewShowMoreProducts}
          dynamicProductWidgetRedirection={dynamicProductWidgetRedirection}
          heading={heading}
          rowNumber={rowNumber}
          banners={banners}
          enableGiftWithProduct={enableGiftWithProduct}
          giftWithProductConfig={giftWithProductConfig}
        />
      </div>
    );
  }
}

function announceCarouselChange(direction){
  const sliderContainer = document.querySelector('.product-widget-slider');
  if (!sliderContainer) return;

  let liveRegion = sliderContainer.querySelector('#carousel-live-region');

  // Create live region only once
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'carousel-live-region';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');

    // Visually hidden styles
    liveRegion.style.position = 'absolute';
    liveRegion.style.width = '1px';
    liveRegion.style.height = '1px';
    liveRegion.style.overflow = 'hidden';
    liveRegion.style.clip = 'rect(0 0 0 0)';
    liveRegion.style.whiteSpace = 'nowrap';

    sliderContainer.prepend(liveRegion);
  }

  // Reset for NVDA re-announcement
  liveRegion.textContent = '';

  window.setTimeout(() => {
    liveRegion.textContent =
      direction === 'next'
        ? 'Products scrolled forward. Use shift tab to check previous products.'
        : 'Products scrolled backward. Use tab to view more products.';
  }, 50);
};

function SampleNextArrow(props) {
  const { className, style, onClick, isDynamicProductWidget = false } = props;
  let showNextArrow = true;
  if (isDynamicProductWidget && className.includes('slick-disabled')) showNextArrow = false;
  return showNextArrow && <div className={className} aria-label="Next" role="button" aria-controls="product-widget-slider" aria-disabled={className.includes('slick-disabled')} tabIndex={className.includes('slick-disabled') ? -1 :0} onClick={(e)=>{
    onClick(e)
    announceCarouselChange('next');
  }} />;
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} aria-label="Previous" aria-controls="product-widget-slider" aria-disabled={className.includes('slick-disabled')} tabIndex={className.includes('slick-disabled') ? -1 :0} role="button" onClick={(e)=>{
    onClick(e)
    announceCarouselChange('previous');
  }} />;
}

class DataList extends React.Component {

updateSlideTabIndex = () => {
  const slides = document.querySelectorAll(
    '.product-widget-slider div[data-index]'
  );

  slides.forEach(slide => {
    const anchor = slide.querySelector('a');
    if (!anchor) return;

    const isActive =
      slide.classList.contains('slick-active') &&
      !slide.classList.contains('slick-cloned');

    anchor.tabIndex = isActive ? 0 : -1;
    anchor.setAttribute('aria-hidden', !isActive);
  });
};


observeSlickChanges = () => {
  const track = document.querySelector(
    '.product-widget-slider .slick-track'
  );

  if (!track) return;

  this.updateSlideTabIndex();

  this.slickObserver = new MutationObserver(() => {
    this.updateSlideTabIndex();
  });

  this.slickObserver.observe(track, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });
};


componentDidMount() {
  this.observeSlickChanges();
}


componentWillUnmount() {
  if (this.slickObserver) {
    this.slickObserver.disconnect();
  }
}

handleAfterChange = () => {
  this.updateSlideTabIndex();
};


  render() {
    const { landing: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const {
      landingList: { widgetList = '' }
    } = luxeList;
    const {
      isPriceReveal,
      newDesignLuxe,
      eventPush,
      currentStore,
      onNextClick,
      priceRevealMetaInfo,
      storesForHidingMRP,
      bannerType,
      ctaSettings,
      viewShowMoreProducts,
      dynamicProductWidgetRedirection,
      heading,
      rowNumber,
      banners,
      enableGiftWithProduct,
      giftWithProductConfig
    } = this.props;
    const isDynamicProductWidget = bannerType === 'DYNAMIC_WIDGET' || false;
    const { enable: isCTAEnabled = false, ctaText = '' } = ctaSettings;
    const slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      lazyLoad: true,
      lazyLoadOffset: 1,
      nextArrow: <SampleNextArrow isDynamicProductWidget={isDynamicProductWidget} />,
      prevArrow: <SamplePrevArrow />,
      afterChange: onNextClick,
      className: 'arrow-styles'
    };

    const dataListItems = this.props.data.map((data, index) => {
      const image = data.mainImage;
      const { offerPrice = {}, catalogName } = data;
      const { displayformattedValue = '', priceReveal = {}, value: offerValue = '', giftAvailable = false } = offerPrice;
      const redirectFn = redirect(data.descriptionPageURL);
      const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
      
      return (
        <div
          key={index}
          className={`${
            !(
              this.props?.data?.length > 4 ||
              (isDynamicProductWidget && isCTAEnabled && dataListItems?.length > 4)
            )
              ? 'product-div-margin-auto'
              : ''
          }`}
        >
          <a
            href={addCustomerType(data.descriptionPageURL)}
            className="product-widget-card"
            target="_self"
            rel=""
            onClick={e => {
              e.preventDefault();
              redirectFn();
              eventPush({
                eventName: 'view_item_list - product-widget',
                event_category: 'widget interactions',
                event_action: 'widget clicks',
                event_label: 'product widget',
                product_name: data.name,
                product_id:
                  data.code && data.code.length > 9 ? data.code.substring(0, 9) : data.code,
                product_brand: data.fnlColorVariantData.brandName,
                product_price: data.wasPriceData.displayformattedValue,
                product_color: data.fnlColorVariantData.colorGroup
                  ? data.fnlColorVariantData.colorGroup.split('_')[1]
                  : '',
                product_size: '',
                product_trade_discount: data.discount,
                product_catogory: data.brickCategory,
                product_brick: data.brickName,
                product_tag: data.fnlColorVariantData.exclusiveTill
                  ? 'EXCLUSIVE'
                  : data.fnlColorVariantData.productTag
              });
        

              let listValue = widgetList;
              if (isDynamicProductWidget) {
                listValue =
                  banners.widgetLevel.toLowerCase() === 'user'
                    ? `user_level_${banners?.feedLogic}_${heading}_${rowNumber}`
                    : `dynamic_${banners?.feedLogic}_${heading}_${rowNumber}`;
                //  debugger
              }
              luxeGtmProductClick({
                name: data.name,
                id: data.code && data.code.length > 9 ? data.code.substring(0, 9) : data.code,
                price: data.wasPriceData.displayformattedValue,
                brand: data.fnlColorVariantData.brandName,
                position: index,
                category: data.brickCategory,
                product_size: '',
                product_color: data.fnlColorVariantData.colorGroup
                  ? data.fnlColorVariantData.colorGroup.split('_')[1]
                  : '',
                product_trade_discount: data.discountPercent,
                product_brick: data.brickName,
                product_tag: data.fnlColorVariantData.exclusiveTill
                  ? 'EXCLUSIVE'
                  : data.fnlColorVariantData.productTag,
                list: listValue,
                store_type: currentStore,
                pageType: screenType,
                pageName: '',
                sourceStore: currentStore,
                containsLuxe: !!newDesignLuxe,
                segmentId: data.segmentId,
                experimentId: data.experimentId,
                offerName: enableGiftWithProduct && giftAvailable ? 'GetFreebies' : ''
              });
              setLandingPageScrollCookies('WEB');
              if (isDynamicProductWidget) {
                const url = addCustomerType(data.descriptionPageURL);
                dynamicProductWidgetRedirection(url);
              } else {
                window.location.href = addCustomerType(data.descriptionPageURL);
              }
            }}
            aria-labelledby={`brand-${data.brand.replace(/\s+/g, '')} description-${data.description.replace(/\s+/g, '')} cp-${data.currentPrice.replace(/\s+/g, '')} sp-${data.actualPrice.replace(/\s+/g, '')} discount-${data.discount.replace(/\s+/g, '')} gwp price-reveal`
          }
          >
            <div
              className={`sec-prod-disp ${newDesignLuxe ? 'prod-widget-desc-disp' : ''}`}
              style={{
                width: newDesignLuxe ? '230px' : '204px',
                height: newDesignLuxe ? '288px' : '256px'
              }}
              ref={ele => {
                if (!ele) return;

                const grandParent = ele.parentElement?.parentElement;
                grandParent.style.textAlign = 'center';
              }}
            >
              <img
                className="product-widget-img"
                src={((replaceWithJioCDN(`${image}`)))}
                alt={data.description || 'product image'}
                width={newDesignLuxe ? '230px' : '204px'}
                height={newDesignLuxe ? '288px' : '256px'}
              />
            </div>

            <div
              className="sec-product-details"
              style={{ width: newDesignLuxe ? '230px' : '204px' }}
            >
              <div className="sec-prod-title" id={`brand-${data.brand.replace(/\s+/g, '')}`} aria-label={data.brand}>
                {data.brand}
              </div>
              {!isPriceReveal && (
                <div className="sec-prod-subtitle prod-widget-desc" id={`description-${data.description.replace(/\s+/g, '')}`} aria-label={data.description}>
                  {data.description}
                </div>
              )}
              {data.price && data.price.displayformattedValue ? (
                <div className="sec-prod-cp" id={`cp-${data.currentPrice.replace(/\s+/g, '')}`} aria-label={`Current Price ${data.currentPrice.replace(/\s+/g, '')}`}>{data.currentPrice}</div>
              ) : (
                ''
              )}

              {data.wasPriceData &&
              data.wasPriceData.value &&
              data.wasPriceData.value > data.price.value &&
              hideMRP ? (
                <div className="sec-prod-price">
                  <span className="sec-prod-sp">
                    <span id={`sp-${data.actualPrice.replace(/\s+/g, '')}`} aria-label={`MRP ${data.actualPrice}`}>{data.actualPrice}</span>
                  </span>
                  &nbsp;
                  <span id={`discount-${data.discount.replace(/\s+/g, '')}`} className="discount-percent" aria-label={`${ data.discount} discount available`}>&nbsp;({data.discount})</span>
                </div>
              ) : (
                ''
              )}
              {/* Add GWP Here for product widget for Desktop */}
              {enableGiftWithProduct && giftAvailable &&
                <div className='gwp-container'>
                  <span id="gwp" className={newDesignLuxe ? 'gwp-text-luxe' : 'gwp-text'}>{giftWithProductConfig.productWidgetTitle}</span>
                </div>
              }
              {/* {isPriceReveal && ( */}
                <PriceRevealPLP
                id="price-reveal"
                  priceRevealClass="pr-pdp-desktop"
                  priceReveal={priceReveal}
                  isPriceReveal={!!isPriceReveal}
                  orignalPrice={data.price.value}
                  offerValue={offerValue}
                  deviceType="desktop"
                  pageType={screenType}
                  luxe={newDesignLuxe}
                />
              {/* )} */}
            </div>
          </a>
        </div>
      );
    });
    if (isDynamicProductWidget && isCTAEnabled) {
      dataListItems.push(
        <div key="show-view-more">
          <div className="product-widget-card"role="link" tabIndex={0} aria-label={`${ctaText} products`} onClick={() => viewShowMoreProducts()}>
            <div
              className={`sec-prod-disp ${newDesignLuxe ? 'prod-widget-desc-disp' : ''}`}
              style={{ width: newDesignLuxe ? '230px' : '204px' }}
            >
              <div
                className={`product-widget-img show-view-more ${newDesignLuxe ? 'luxe-bg' : ''}`}
                style={{
                  width: newDesignLuxe ? '230px' : '204px',
                  height: newDesignLuxe ? '288px' : '256px'
                }}
              >
                <div className="view-more-container">
                  <p className="ctaText">{ctaText}</p>
                  <img
                    alt="Right arrow"
                    src={`${imageBaseUrl}/static/img/show-view-more-arrow.svg`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (
      this.props.data.length > 4 ||
      (isDynamicProductWidget && isCTAEnabled && dataListItems.length > 4)
    ) {
      return (
        <div
          className={`product-widget-slider ${
            isDynamicProductWidget ? 'dynamic-product-widget-slider' : ''
          }`}
        >
          <Slider {...slickSettings} ref="slick" afterChange={this.handleAfterChange}>
            {dataListItems}
          </Slider>
        </div>
      );
    } else {
      return (
        <div
          className={`product-widget-slider ${
            isDynamicProductWidget ? 'dynamic-product-widget-slider' : ''
          }`}
        >
          <Row className="center">{dataListItems}</Row>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {}, metaData = {} } = state;
  const { sis, name } = metaData;
  const storeName = getCurrentStore(state);
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    productWidgetData: ownProps.products,
    metaData: state.metaData,
    flags: state.flags,
    priceRevealV2WebFeatureFlag: getPriceRevealV2WebFeatureFlag(flags),
    priceRevealV2WebData: getPriceRevealWebData(flags),
    store: sis ? name : 'AJIO',
    priceRevealLUXEFlag: getPriceRevealLUXEFlag(flags),
    currentStore: storeName,
    newDesignLuxe,
    storesForHidingMRP: getStoresForHidingMRP(state),
    enableGiftWithProduct: getGiftWithProductEnable(flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
  };
};

export default ProductWidget = connect(mapStateToProps)(ProductWidget);
